export const acceptCookies = () => {
  const consent = "cookieConsent=true";

  const date = new Date();
  date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000); // 365 day expiry
  const expires = `expires=${date.toUTCString()}`;

  document.cookie = [consent, expires].join(";");
};

export const checkConsent = () => {
  return !!decodeURIComponent(document.cookie)
    .split(";")
    .filter(item => item.trim().startsWith("cookieConsent=")).length;
};
